import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';

import { isInEnum } from '../../../utils/isInEnum';
import { RefinanceGoal } from '../enums/RefinanceGoal';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromMailCode } from '../types/HydrateFromMailCode';

export const toApplyStateFromMailCode = (
  mailCode: HydrateFromMailCode,
): Partial<ApplyState> => {
  const applicationType = isInEnum(mailCode.applicationType, ApplicationType)
    ? mailCode.applicationType
    : ApplicationType.REFINANCE;

  const payoffAmount: string | null =
    applicationType === ApplicationType.REFINANCE
      ? mailCode.payoffAmount
      : null;

  const refinanceGoal: RefinanceGoal | null =
    applicationType === ApplicationType.REFINANCE
      ? RefinanceGoal.LOWER_PAYMENT
      : null;

  return {
    applicationType,
    payoffAmount,
    refinanceGoal,
  };
};
